import {
  AppShell
} from "@mantine/core";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Navbar from "./Navbar";
import { RenewModal, SubscriptionBanner } from "@/modules/subscription/SubscriptionNotices";


function DesktopLayout() {





  // const [opened, { toggle }] = useDisclosure(false);
  return (

    <AppShell
      layout="alt"
      header={{ height: 60 }}
      navbar={{ width: "250px", breakpoint: 'sm' }}
      padding="md"
    >
      <AppShell.Header>
        <Header />
      </AppShell.Header>
      <AppShell.Navbar styles={{
        navbar: {
          zIndex: 1,
          padding: 0
        }
      }}>
        <Navbar />
      </AppShell.Navbar>
      <AppShell.Main>
        <SubscriptionBanner />
        <Outlet />
        <RenewModal />
      </AppShell.Main>

    </AppShell >

    // <AppShell
    //   header={{ height: 60 }}
    //   navbar={{
    //     width: 300,
    //     breakpoint: "sm",
    //     // collapsed: { mobile: !opened },
    //   }}
    //   padding="md"
    // >
    //   <AppShellHeader >
    //     <Header />
    //   </AppShellHeader>
    //   <AppShellNavbar>
    //     <Navbar />
    //   </AppShellNavbar>

    //   <AppShell.Main>
    //     <Outlet />
    //   </AppShell.Main>
    //   <AppShellFooter>asdas</AppShellFooter>
    // </AppShell>
  );
}

export default DesktopLayout;
